import React from 'react';

function Australia(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124197)">
        <mask
          id="mask0_800_124197"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124197)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#2E42A5"
          />
          <mask
            id="mask1_800_124197"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124197)">
            <rect width="20.25" height="14" fill="#2B409A" />
            <mask
              id="mask2_800_124197"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="21"
              height="14"
            >
              <rect width="20.25" height="14" fill="white" />
            </mask>
            <g mask="url(#mask2_800_124197)">
              <path
                d="M-2.25488 12.9998L2.20119 14.737L20.351 1.88872L22.7015 -0.69281L17.9364 -1.27343L10.5335 4.26326L4.57493 7.99369L-2.25488 12.9998Z"
                fill="#F7FCFF"
              />
              <path
                d="M-1.64502 14.2169L0.625142 15.225L21.8573 -0.932678H18.6697L-1.64502 14.2169Z"
                fill="#F50100"
              />
              <path
                d="M22.5049 12.9998L18.0488 14.737L-0.101032 1.88872L-2.45151 -0.69281L2.31362 -1.27343L9.71651 4.26326L15.6751 7.99369L22.5049 12.9998Z"
                fill="#F7FCFF"
              />
              <path
                d="M22.353 13.8733L20.0829 14.8815L11.042 7.96351L8.36158 7.19059L-2.67748 -0.683947H0.510086L11.5429 7.00368L14.4735 7.9305L22.353 13.8733Z"
                fill="#F50100"
              />
              <mask
                id="path-11-outside-1_800_124197"
                maskUnits="userSpaceOnUse"
                x="-2"
                y="-2"
                width="24"
                height="18"
                fill="black"
              >
                <rect fill="white" x="-2" y="-2" width="24" height="18" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.2326 0H8.98256V6H0V8H8.98256V14H11.2326V8H20.25V6H11.2326V0Z"
                />
              </mask>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.2326 0H8.98256V6H0V8H8.98256V14H11.2326V8H20.25V6H11.2326V0Z"
                fill="#F50100"
              />
              <path
                d="M8.98256 0V-1.5H7.48256V0H8.98256ZM11.2326 0H12.7326V-1.5H11.2326V0ZM8.98256 6V7.5H10.4826V6H8.98256ZM0 6V4.5H-1.5V6H0ZM0 8H-1.5V9.5H0V8ZM8.98256 8H10.4826V6.5H8.98256V8ZM8.98256 14H7.48256V15.5H8.98256V14ZM11.2326 14V15.5H12.7326V14H11.2326ZM11.2326 8V6.5H9.73256V8H11.2326ZM20.25 8V9.5H21.75V8H20.25ZM20.25 6H21.75V4.5H20.25V6ZM11.2326 6H9.73256V7.5H11.2326V6ZM8.98256 1.5H11.2326V-1.5H8.98256V1.5ZM10.4826 6V0H7.48256V6H10.4826ZM0 7.5H8.98256V4.5H0V7.5ZM1.5 8V6H-1.5V8H1.5ZM8.98256 6.5H0V9.5H8.98256V6.5ZM10.4826 14V8H7.48256V14H10.4826ZM11.2326 12.5H8.98256V15.5H11.2326V12.5ZM9.73256 8V14H12.7326V8H9.73256ZM20.25 6.5H11.2326V9.5H20.25V6.5ZM18.75 6V8H21.75V6H18.75ZM11.2326 7.5H20.25V4.5H11.2326V7.5ZM9.73256 0V6H12.7326V0H9.73256Z"
                fill="#F7FCFF"
                mask="url(#path-11-outside-1_800_124197)"
              />
            </g>
          </g>
          <path
            d="M10.75 20.5L9.44835 21.7029L9.57725 19.9352L7.82522 19.6676L9.28761 18.6662L8.40451 17.1295L10.0992 17.6485L10.75 16L11.4008 17.6485L13.0955 17.1295L12.2124 18.6662L13.6748 19.6676L11.9227 19.9352L12.0517 21.7029L10.75 20.5Z"
            fill="#F7FCFF"
          />
          <path
            d="M23.75 13L22.8822 13.8019L22.9682 12.6235L21.8001 12.445L22.7751 11.7775L22.1863 10.753L23.3161 11.099L23.75 10L24.1839 11.099L25.3137 10.753L24.7249 11.7775L25.6999 12.445L24.5318 12.6235L24.6178 13.8019L23.75 13Z"
            fill="#F7FCFF"
          />
          <path
            d="M25.75 5L24.8822 5.80194L24.9682 4.62349L23.8001 4.44504L24.7751 3.77748L24.1863 2.75302L25.3161 3.09903L25.75 2L26.1839 3.09903L27.3137 2.75302L26.7249 3.77748L27.6999 4.44504L26.5318 4.62349L26.6178 5.80194L25.75 5Z"
            fill="#F7FCFF"
          />
          <path
            d="M30.75 9L29.8822 9.80194L29.9682 8.62349L28.8001 8.44504L29.7751 7.77748L29.1863 6.75302L30.3161 7.09903L30.75 6L31.1839 7.09903L32.3137 6.75302L31.7249 7.77748L32.6999 8.44504L31.5318 8.62349L31.6178 9.80194L30.75 9Z"
            fill="#F7FCFF"
          />
          <path
            d="M26.75 22L25.8822 22.8019L25.9682 21.6235L24.8001 21.445L25.7751 20.7775L25.1863 19.753L26.3161 20.099L26.75 19L27.1839 20.099L28.3137 19.753L27.7249 20.7775L28.6999 21.445L27.5318 21.6235L27.6178 22.8019L26.75 22Z"
            fill="#F7FCFF"
          />
          <path
            d="M30.25 14.25L29.3683 14.7135L29.5367 13.7318L28.8234 13.0365L29.8092 12.8932L30.25 12L30.6908 12.8932L31.6766 13.0365L30.9633 13.7318L31.1317 14.7135L30.25 14.25Z"
            fill="#F7FCFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124197">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Australia;
